module.exports = __webpack_public_path__ + "static/media/folder.2f1d63b4.svg";